import { AssignMobileOfferRequest, MobileOfferCatalogEntry, MobileOfferCustomer } from '@numeo/types'
import { ShieldCheck } from 'lucide-react'
import { CustomerActionDialog } from './CustomerActionDialog'
import { CustomerOfferSummary } from './CustomerOfferSummary'
import { customerOfferDate, customerOfferSecondaryClass } from './customer-offer-utils'
import { OfferButton, OfferNotice } from './ui'

interface CustomerAssignmentReviewProps {
    customer: MobileOfferCustomer
    request: AssignMobileOfferRequest
    offer: MobileOfferCatalogEntry
    busy: boolean
    consent: boolean
    error: string
    onConsent: (value: boolean) => void
    onClose: () => void
    onConfirm: () => void
}

export function CustomerAssignmentReview({ customer, request, offer, busy, consent, error, onConsent, onClose, onConfirm }: CustomerAssignmentReviewProps) {
    return (
        <CustomerActionDialog
            title="Review assignment"
            busy={busy}
            onClose={onClose}
            footer={
                <div className="space-y-4">
                    <label className="flex items-start gap-3 text-sm">
                        <input type="checkbox" checked={consent} disabled={busy} onChange={(event) => onConsent(event.target.checked)} className="mt-1" />
                        <span>I confirmed this signup identity and store with the customer.</span>
                    </label>
                    {error && <OfferNotice error>{error}</OfferNotice>}
                    <div className="flex flex-wrap justify-end gap-3">
                        <OfferButton variant="secondary" disabled={busy} onClick={onClose}>
                            Back to edit
                        </OfferButton>
                        <OfferButton disabled={!consent || busy} onClick={onConfirm}>
                            {busy ? 'Confirming…' : 'Confirm assignment'}
                        </OfferButton>
                    </div>
                </div>
            }
        >
            <div className="space-y-5">
                <div>
                    <h3 className="font-semibold">{customer.name || 'Customer'}</h3>
                    <p className={customerOfferSecondaryClass}>
                        {customer.email || 'No signup email'} · {customer.phone || 'No phone number'}
                    </p>
                    <p className="mt-1 break-all text-xs text-slate-500 dark:text-slate-400">Account {customer.userId}</p>
                </div>
                <CustomerOfferSummary offer={offer} provider={request.provider} />
                <dl className="space-y-3 text-sm">
                    <div>
                        <dt className="text-slate-500 dark:text-slate-400">Redeem before · {Intl.DateTimeFormat().resolvedOptions().timeZone}</dt>
                        <dd className="mt-1 font-medium">{customerOfferDate(request.redeemBy)}</dd>
                    </div>
                    <div>
                        <dt className="text-slate-500 dark:text-slate-400">Assignment reason</dt>
                        <dd className="mt-1 whitespace-pre-wrap break-words">{request.reason}</dd>
                    </div>
                </dl>
                <div className="flex items-start gap-2 rounded-lg bg-blue-50 p-3 text-sm text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                    <ShieldCheck className="h-5 w-5 shrink-0" />
                    <span>
                        Assignment does not activate a subscription. The customer must complete the store purchase, subject to eligibility and availability.
                    </span>
                </div>
            </div>
        </CustomerActionDialog>
    )
}
